const rawOptions = window.SERVER_DATA || {
  launchDarklyKey: "61aa209c0be7e9119fa08c26",
  environment: "development",
  zendeskKey: "8dd434ec-f47b-487f-9d77-399e5307422d",
  apiUrl: "http://localhost:3001/api",
  beamerProductId: "CGmmIQAb64246",
  googleMapsApiKey: "AIzaSyCWhTQ-9U63oV9A9XAhQPQ3I6ZSiCkZpXk",
}; // Default to development values if no window.SERVER_DATA is present

export const options = {
  ...rawOptions,
  apiUrl: rawOptions.apiUrl.startsWith("/")
    ? `${window.location.origin}${rawOptions.apiUrl}`
    : rawOptions.apiUrl,
};